export default defineNuxtPlugin((nuxtApp) => {
  if (typeof window === "undefined") return; // ✅ Vérifie si le code s'exécute côté client

  const runtimeConfig = useRuntimeConfig();
  const gtmId = runtimeConfig.public.gtmId || process.env.GTM_ID;

  if (!gtmId) {
    console.warn("⚠️ Google Tag Manager ID manquant.");
    return;
  }

 // console.log(`🎯 GTM ID chargé : ${gtmId}`);

  // 📌 Injecte Google Tag Manager
  const gtmScript = document.createElement("script");
  gtmScript.async = true;
  gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  document.head.appendChild(gtmScript);

  // 📌 Injecte Google Analytics 4 (GA4)
  const gaScript = document.createElement("script");
  gaScript.async = true;
  gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${gtmId}`;
  document.head.appendChild(gaScript);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }

  gtag("js", new Date());
  gtag("config", gtmId);

  nuxtApp.provide("trackPurchase", (orderId, totalAmount, currency = "EUR") => {
    gtag("event", "purchase", {
      transaction_id: orderId,
      value: totalAmount,
      currency: currency,
    });

    /*console.log(
      `🛒 Achat suivi : ID ${orderId}, Montant ${totalAmount} ${currency}`
    );*/
  });

  // 📊 Suivi des pages
  nuxtApp.hook("page:finish", () => {
    gtag("event", "page_view", {
      page_location: window.location.href,
      page_path: window.location.pathname,
      page_title: document.title,
    });

    console.log("📊 Page vue envoyée :", window.location.pathname);
  });
});

/*export default defineNuxtPlugin((nuxtApp) => {
  if (!import.meta.client) return;

  const runtimeConfig = runtimeConfig();
  const gtmId = runtimeConfig.public.gtmId || process.env.GTM_ID;

  if (!gtmId) {
    console.warn("⚠️ Google Tag Manager ID manquant.");
    return;
  }

  console.log(`🎯 GTM ID chargé : ${gtmId}`);

  // 📌 Insérer GTM (Google Tag Manager)
  const gtmScript = document.createElement("script");
  gtmScript.async = true;
  gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  document.head.appendChild(gtmScript);

  // 📌 Insérer GTAG (Google Analytics 4)
  const gaScript = document.createElement("script");
  gaScript.async = true;
  gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${gtmId}`;
  document.head.appendChild(gaScript);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }

  gtag("js", new Date());
  gtag("config", gtmId);

  // 📊 Suivi des achats (E-commerce GA4)
  nuxtApp.provide("trackPurchase", (orderId, totalAmount, currency = "EUR") => {
    gtag("event", "purchase", {
      transaction_id: orderId,
      value: totalAmount,
      currency: currency,
    });

    console.log(
      `🛒 Achat suivi : ID ${orderId}, Montant ${totalAmount} ${currency}`
    );
  });

  // 📍 Suivi automatique des pages vues (page_view)
  nuxtApp.hook("page:finish", () => {
    gtag("event", "page_view", {
      page_location: window.location.href,
      page_path: window.location.pathname,
      page_title: document.title,
    });

    console.log("📊 Page vue envoyée :", window.location.pathname);
  });
});
*/
